export default __webpack_public_path__ + "ui/assets/img/arrow-left-success-32.svg";